import { Br } from "../molecules/Br";

export const AboutAccessMap = (props) => {
  const defaultLatLng = {
    lat: 35.7022589,
    lng: 139.7744733,
  };

  const handleApiLoaded = ({ map, maps }) => {
    new maps.Marker({
      map,
      position: defaultLatLng,
    });
  };
  return (
    <div id="accessMap" className="--offset">
      <div className="relative mx-auto box-border max-w-7xl">
        <div className="grid grid-cols-1 gap-4 px-6 sm:px-8 md:grid-cols-4 md:px-12 lg:gap-0 xl:px-0">
          <div className="col-span-1 space-y-4 md:space-y-10 lg:pr-20">
            <h3 className="font-bold text-ter fluid-text-[16px,18px]">
              Access Map
            </h3>
            <div className="leading-relaxed fluid-text-[12px,16px]">
              地下鉄半蔵門線・新宿線・三田線　神保町駅A4出口から徒歩2分
              <Br />
              地下鉄東西線・半蔵門線・新宿線　九段下駅から徒歩8分
              <Br />
              JR中央・総武緩行線　水道橋駅東口から徒歩8分
            </div>
          </div>
          <div className="col-span-1 md:col-span-3">
            <iframe
              className="aspect-1.618/1 w-full border-0"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6480.3884821530655!2d139.7527!3d35.6968374!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188c15b83a794d%3A0xf7ef2d6128d60e6c!2z44ix44OI44OD44Kr44K344K544OG44Og44K6!5e0!3m2!1sja!2sjp!4v1660756436504!5m2!1sja!2sjp"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};
